export default __webpack_public_path__ + "static/illustration-standards-f86e3d1e03efcb2d3ad7b5af80336330.svg";